(function () {
  var CART_MUTATION_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/i;

  function formatMoney(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    return (cents / 100).toLocaleString(undefined, {
      style: 'currency',
      currency: currency,
    });
  }

  function update(totalCents) {
    document.querySelectorAll('[data-cart-free-shipping-bar]').forEach(function (bar) {
      var threshold = parseInt(bar.dataset.threshold, 10);
      if (!threshold) return;
      var remaining = Math.max(threshold - totalCents, 0);
      var progress = Math.min((totalCents / threshold) * 100, 100);

      var fill = bar.querySelector('[data-cart-free-shipping-bar-fill]');
      if (fill) {
        fill.style.width = progress + '%';
        if (remaining === 0) {
          fill.classList.add('cart-free-shipping-bar__fill--complete');
        } else {
          fill.classList.remove('cart-free-shipping-bar__fill--complete');
        }
      }

      var msg = bar.querySelector('[data-cart-free-shipping-bar-message]');
      if (msg) {
        if (remaining > 0) {
          msg.innerHTML =
            "You're <strong>" +
            formatMoney(remaining) +
            "</strong> away from <strong>free standard shipping</strong>";
        } else {
          msg.innerHTML = "You've unlocked <strong>free shipping</strong>";
        }
      }
      bar.dataset.cartTotal = totalCents;
    });
  }

  var refreshTimer = null;
  function refreshFromCart() {
    if (refreshTimer) clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () {
      fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (cart) { update(cart.total_price); })
        .catch(function () {});
    }, 60);
  }

  // Intercept fetch() — catches the modern Shopify theme cart mutations.
  if (typeof window.fetch === 'function') {
    var origFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = '';
      try { url = typeof input === 'string' ? input : (input && input.url) || ''; } catch (e) {}
      var isCartMutation = CART_MUTATION_RE.test(url);
      var promise = origFetch.apply(this, arguments);
      if (isCartMutation) {
        promise.then(refreshFromCart, refreshFromCart);
      }
      return promise;
    };
  }

  // Intercept XMLHttpRequest — catches older cart libraries that still use XHR.
  if (typeof window.XMLHttpRequest === 'function') {
    var origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      try {
        if (typeof url === 'string' && CART_MUTATION_RE.test(url)) {
          this.addEventListener('loadend', refreshFromCart);
        }
      } catch (e) {}
      return origOpen.apply(this, arguments);
    };
  }

  // Belt-and-suspenders: theme custom events some Shopify themes emit.
  document.addEventListener('cart:updated', refreshFromCart);
  document.addEventListener('shopify:cart:updated', refreshFromCart);

  // Initial sync — handles the case where the page was rendered with a stale total.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshFromCart);
  } else {
    refreshFromCart();
  }
})();
